import React from 'react'

export interface BadgeProps {
  children: React.ReactNode
  variant?: 
    | 'default' 
    | 'success' 
    | 'warning' 
    | 'error' 
    | 'info'
    | 'platform-linkedin'
    | 'platform-indeed'
    | 'platform-glassdoor'
    | 'status-active'
    | 'status-paused'
    | 'status-completed'
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const variantStyles: Record<string, string> = {
  default: 'bg-surface-muted text-text-primary',
  success: 'bg-brand-primary-subtle text-brand-primary-strong',
  warning: 'bg-warning-subtle text-warning',
  error: 'bg-danger-subtle text-danger-strong',
  info: 'bg-info-subtle text-info',
  'platform-linkedin': 'bg-brand-primary-subtle text-brand-primary',
  'platform-indeed': 'bg-purple-100 text-purple-800',
  'platform-glassdoor': 'bg-brand-primary-subtle text-brand-primary-strong',
  'status-active': 'bg-brand-primary-subtle text-brand-primary-strong',
  'status-paused': 'bg-danger-subtle text-danger-strong',
  'status-completed': 'bg-surface-muted text-text-secondary',
}

const sizeStyles: Record<string, string> = {
  sm: 'px-2 py-1 text-small',
  md: 'px-3 py-1.5 text-body',
  lg: 'px-4 py-2 text-base',
}

function Badge({ 
  children, 
  variant = 'default', 
  size = 'sm',
  className = '' 
}: BadgeProps) {
  const baseStyles = 'rounded-sm font-medium inline-block'
  const variantStyle = variantStyles[variant] || variantStyles.default
  const sizeStyle = sizeStyles[size] || sizeStyles.sm

  return (
    <span className={`${baseStyles} ${variantStyle} ${sizeStyle} ${className}`}>
      {children}
    </span>
  )
}

export default Badge
